import { render, staticRenderFns } from "./shijianbanli.vue?vue&type=template&id=46bea254&scoped=true&"
import script from "./shijianbanli.vue?vue&type=script&lang=js&"
export * from "./shijianbanli.vue?vue&type=script&lang=js&"
import style0 from "./shijianbanli.vue?vue&type=style&index=0&id=46bea254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bea254",
  null
  
)

export default component.exports